import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { MentionsInput, Mention } from 'react-mentions';
import { withStyles } from '@material-ui/core/styles';
import combineStyles from '../../../utils/combineStyles';
import classnames from 'classnames';

import CommentsInputStyles from './CommentsInput.module.css';
import IconButton from '@material-ui/core/IconButton';
import ArrowIcon from '@material-ui/icons/SendOutlined';
import ArrowFilledIcon from '@material-ui/icons/Send';
import SpacingStyles from './../../../styles/helpers/spacing';

const CommentStyles = theme => ({
  commentWrapper: {
    border: '1px solid rgba(12,31,44,0.12)',
    borderRadius: '4px',
    padding: theme.spacing.unit,
    display: 'flex',
    alignContent: 'flex-start'
  },
  contentWrapper: {
    padding: theme.spacing.unit * 3,
    borderBottom: '1px solid #E6E8E9'
  },
  commentInput: {
    border: 'none',
    outline: 'none'
  },
  outlinedArrow: {
    color: 'rgba(12,31,44,0.38)'
  },
  arrowButton: {
    '&:hover': {
      backgroundColor: '#fff'
    }
  }
});

export class CommentInput extends PureComponent {
  static propTypes = {
    onSave: PropTypes.func.isRequired,
    users: PropTypes.array.isRequired
  };
  state = {
    value: ''
  };
  handleChange = ({ target: { value } }) => {
    this.setState({ value });
  };
  _resetComment = () => {
    this.setState({ value: '' });
  };
  render() {
    const { classes, onSave, users } = this.props;
    const { value } = this.state;
    return (
      <div className={classes.contentWrapper}>
        <div className={classes.commentWrapper}>
          <MentionsInput
            value={value}
            onChange={this.handleChange}
            placeholder="Leave a comment..."
            classNames={CommentsInputStyles}
          >
            <Mention trigger="@" data={users} />
          </MentionsInput>
          <IconButton
            color="primary"
            onClick={() => {
              if (value.length > 0) {
                onSave(value);
                this._resetComment();
              }
            }}
            classes={{
              root: classnames(classes.noPadding, classes.arrowButton, {
                [classes.outlinedArrow]: value.length === 0
              })
            }}
          >
            {value.length > 0 ? <ArrowFilledIcon /> : <ArrowIcon />}
          </IconButton>
        </div>
      </div>
    );
  }
}

export default withStyles(combineStyles(CommentStyles, SpacingStyles))(
  CommentInput
);
